const Glossary = () => {
    return {
        /**
         * @param {jQuery} $selector
         *
         */
        init: function ($selector) {

            if (!$selector) {
                $selector = $(document);
            } else {
                if (!($selector instanceof $)) {
                    $selector = $($selector);
                }
            }
            $selector.off('click', 'button');
            $selector.on('click', 'button', function (e) {
                var buttonFilter,
                    searchResult;
                searchResult = $('.bootstrap-table input');
                buttonFilter = $(this).data('setu-filter');

                if (searchResult.val()) {
                    $('#btnFilter button').mouseover(function () {
                        $('.bootstrap-table span.btn').click();
                    })
                }
                $('#btnFilter button').not('.btn-third').addClass('btn-default');
                $('.filter').removeClass('hidden');

                $('.mb-3').on('click', 'input', function () {
                    $('#btnFilter button').addClass('btn-default');
                });

                $(this).removeClass('btn-default').addClass('btn-primary');
                $('.filter').not('.' + buttonFilter).addClass('hidden');
                $('.filter').filter('.' + buttonFilter).removeClass('hidden');
            });
        }
    }
};

export const glossary = Glossary();
